import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_STATISTICS_V2_APP_PATHS } from '../../shared/statistics/constants/path.constants';
import AdminStatisticsOverviewView from '../views/AdminStatisticsOverview.view';

export default function AdminStatisticsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_STATISTICS_V2_APP_PATHS.OVERVIEW} component={AdminStatisticsOverviewView} />
    </React.Fragment>
  );
}
